import { TaxonomyChild } from 'entities/tag';

/** Walk the tree to find the path of ancestor IDs leading to `targetId`. */
export const findAncestorPath = (nodes: TaxonomyChild[], targetId: string): string[] | null => {
  for (const node of nodes) {
    if (node.id === targetId) return [];
    if (node.children.length > 0) {
      const path = findAncestorPath(node.children, targetId);
      if (path !== null) return [node.id, ...path];
    }
  }
  return null;
};
